import { render, staticRenderFns } from "./UnitGeoReturnMoveModal.vue?vue&type=template&id=20ff1827&"
import script from "./UnitGeoReturnMoveModal.vue?vue&type=script&lang=js&"
export * from "./UnitGeoReturnMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports